const NAV_ITEM_STATES = {
  CLOSE: 0,
  OPEN: 1
};

function toggleNavItems(navItem, targetState = NAV_ITEM_STATES.OPEN) {
  const sitecontent = document.getElementById('sitecontent');

  if (!navItem || !sitecontent) {
    return;
  }

  if (navItem.classList.contains('init')) {
    navItem.classList.remove('init');
    navItem.classList.add('closed');
  }

  targetState === NAV_ITEM_STATES.OPEN ? sitecontent.classList.add('nav-open') : sitecontent.classList.remove('nav-open');
  navItem.classList.add(targetState === NAV_ITEM_STATES.OPEN ? 'open' : 'closed');
  navItem.classList.remove(targetState === NAV_ITEM_STATES.OPEN ? 'closed' : 'open');

  const navContent = navItem.querySelector('.nav-item > .nav-content');
  if (navContent) {
    if (targetState === NAV_ITEM_STATES.OPEN) {
      navContent.classList.remove('menu-disabled');
    } else {
      navContent.classList.add('menu-disabled');
    }
  }

  const menuButton = document.querySelector('.nav-item > .nav-button');
  const currentState = navItem.classList.contains('open') ? NAV_ITEM_STATES.OPEN : NAV_ITEM_STATES.CLOSE;

  if (window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      event: 'mainNavToggleClick',
      customClickText: menuButton.textContent.trim(),
      customClickClasses: menuButton.getAttribute('class')
    });
  }

  menuButton.textContent = currentState === NAV_ITEM_STATES.OPEN ? menuButton.getAttribute('data-closed-text') : menuButton.getAttribute('data-open-text');
}

function handleNavButtonKeydown(event) {
  if (event.key === 'Enter') {
    event.preventDefault();

    const targetItem = event.currentTarget.parentElement;
    const shouldOpen = !targetItem.classList.contains('open');

    toggleNavItems(document.querySelector('.nav-item.open'), NAV_ITEM_STATES.CLOSE);

    if (shouldOpen) {
      toggleNavItems(targetItem, NAV_ITEM_STATES.OPEN);
    }
  }
}

function isTouchDevice() {
  let hasTouchScreen = false;
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = matchMedia?.('(pointer:coarse)');
    if (mQ?.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true;
    } else {
      const UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }

  return hasTouchScreen;
}

function isLikelyMobileDevice() {
  const aspectRatio = window.innerWidth / window.innerHeight;
  return aspectRatio < 1.55;
}

function toggleMobileMenu() {
  const targetItem = document.querySelector('.nav-item-main');
  const shouldOpen = !targetItem.classList.contains('open');

  toggleNavItems(document.querySelector('.nav-item.open'), NAV_ITEM_STATES.CLOSE);

  if (shouldOpen) {
    toggleNavItems(targetItem, NAV_ITEM_STATES.OPEN);
  }
}

function toggleSubMenu(currentTarget) {
  const navItemSub = currentTarget.parentElement;
  const subMenu = navItemSub.querySelector('ul');

  document.querySelectorAll('.nav-container.sub-open').forEach(item => {
    if (item !== navItemSub) {
      item.classList.remove('sub-open');
    }
  });

  if (!subMenu) {
    toggleMobileMenu();
  }

  navItemSub.classList.toggle('sub-open');
}

export default () => {
  const mainNavButton = document.querySelector('.nav-item > .nav-button');
  const sitecontent = document.getElementById('sitecontent');

  if (!sitecontent) {
    return;
  }

  document.querySelectorAll('.nav-item.hoverable').forEach(item => item.classList.remove('hoverable'));

  if (mainNavButton) {
    mainNavButton.addEventListener('click', () => {
      toggleMobileMenu();
    });
  }

  sitecontent.addEventListener('click', () => {
    toggleNavItems(document.querySelector('.nav-item.open'), NAV_ITEM_STATES.CLOSE);
  });

  // mobile main menu (sub navigation)
  document.querySelectorAll('.nav-container-main').forEach(button => {
    button.addEventListener('click', e => {
      toggleSubMenu(e.currentTarget);
    });

    button.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        toggleSubMenu(e.currentTarget);
        e.preventDefault();
      }
    });
  });

  document.querySelectorAll('.category-item').forEach(item => {
    const toggleElement = item.querySelector('.category-title > *');
    const submenu = item.querySelector('.category-menu');

    toggleElement.addEventListener('focus', function() {
      submenu.setAttribute('aria-expanded', 'true');
    });

    toggleElement.addEventListener('keydown', function(event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        const firstItem = submenu.querySelector('a');
        if (firstItem) {
          firstItem.focus();
        }
      }
    });

    item.addEventListener('focusout', function() {
      setTimeout(() => {
        if (!item.contains(document.activeElement)) {
          submenu.setAttribute('aria-expanded', 'false');
        }
      }, 0);
    });
  });

  // allows for toggling submenu on mobile devices
  if (isTouchDevice() && isLikelyMobileDevice()) {
    document.querySelectorAll('.category-title a').forEach(item => {
      item.addEventListener('click', function(event) {
        const isMenuOpen = this.parentNode.nextElementSibling.classList.contains('show-menu');

        document.querySelectorAll('.category-menu').forEach(function(el) {
          el.classList.remove('show-menu');
        });
        if (!isMenuOpen) {
          event.preventDefault();
          this.parentNode.nextElementSibling.classList.toggle('show-menu');
        } else {
          window.location = this.href;
        }
      });

      item.addEventListener('dblclick', function() {
        window.location = this.href;
      });
    });
  }

  const navButton = document.querySelector('.nav-button');
  if (navButton) {
    navButton.addEventListener('keydown', handleNavButtonKeydown);
  }

  const currentYearElement = document.getElementById('current-year');
  if (currentYearElement) {
    const currentYear = new Date().getFullYear();
    currentYearElement.textContent = '© ' + currentYear;
  }
};
